import React from "react";
import './homepage.styles.scss'
import NewsTile from "../../components/NewsTile/newstile.component";
import data from "../../components/NewsTile/tileData";

function Home() {
  return (
    <div>
      <NewsTile data={data} />
    </div>
  );
}

export default Home;
